export const directions = [
  {
    id: "scenic",
    name: "景区现场",
    desc: "入园排队、客流密度与现场秩序的一手实况。",
    iconClass: "ri-map-2-line",
  },
  {
    id: "traveler",
    name: "游客见闻",
    desc: "逛哪、几点去、值不值得，来自同路人亲历分享。",
    iconClass: "ri-chat-3-line",
  },
  {
    id: "hotel",
    name: "酒店踩雷",
    desc: "货不对板、临时涨价与到店无房的高频雷区汇总。",
    iconClass: "ri-hotel-line",
  },
  {
    id: "traffic",
    name: "交通拥堵实况",
    desc: "高速、高铁与城市通勤的拥堵时段与绕行提醒。",
    iconClass: "ri-roadster-line",
  },
  {
    id: "chaos",
    name: "旅游乱象",
    desc: "黄牛揽客、诱导消费等乱象线索，见一条爆一条。",
    iconClass: "ri-alert-line",
  },
];

export const hotRank = [
  {
    rank: 1,
    title: "热门古城「排队进山 4 小时」现场实录刷屏",
    tag: "景区现场",
    heat: 9.8,
    note: "午间客流达到预约上限，入口临时限流。",
  },
  {
    rank: 2,
    title: "多路段返程拥堵延至深夜，高速口积压明显",
    tag: "交通拥堵",
    heat: 9.5,
    note: "主要跨省干道午后至晚间持续缓行。",
  },
  {
    rank: 3,
    title: "游客晒「网红民宿货不对板」对比照引热议",
    tag: "酒店踩雷",
    heat: 8.9,
    note: "实拍与原图差异大，平台已介入核实。",
  },
  {
    rank: 4,
    title: "「黄牛高价代排队」再现，景区呼吁勿轻信",
    tag: "旅游乱象",
    heat: 8.2,
    note: "建议通过官方预约与正规入口进入。",
  },
  {
    rank: 5,
    title: "某海湾观光船安全提示缺失，多名网友质疑",
    tag: "游客见闻",
    heat: 7.7,
    note: "属地文旅部门已收到线索并着手核查。",
  },
  {
    rank: 6,
    title: "景区预约放票「秒空」，转售渠道乱象抬头",
    tag: "旅游乱象",
    heat: 7.3,
    note: "非官方渠道购票需警惕无法核销风险。",
  },
];

export const liveUpdates = [
  {
    time: "14:20",
    category: "景区现场",
    title: "古城核心区客流达到峰值，出入口分时放行",
    detail: "现场安保引导分批进入，建议错峰至黄昏再逛。",
  },
  {
    time: "13:48",
    category: "交通拥堵",
    title: "绕城高速北段多起追尾，现缓行约 8 公里",
    detail: "事故已基本清场，排队仍在消化，可改走辅路。",
  },
  {
    time: "13:12",
    category: "酒店踩雷",
    title: "有游客爆料到店无房，平台称正在协调退款",
    detail: "下单页与到店房型不符，留意平台承诺的赔付条款。",
  },
  {
    time: "12:40",
    category: "游客见闻",
    title: "「观景平台」早场人流稀疏，想清净建议赶早",
    detail: "同路人实测 8 点前入园体验最佳，午后明显拥挤。",
  },
  {
    time: "12:05",
    category: "旅游乱象",
    title: "景区电瓶车「私自揽客」被叫停，增设执法点",
    detail: "属地已对非官方摆渡加收费用行为进行处置。",
  },
  {
    time: "11:32",
    category: "景区现场",
    title: "文创市集入口现插队纠纷，安保已介入疏导",
    detail: "现场秩序逐步恢复，排队请认准隔离带。",
  },
  {
    time: "10:58",
    category: "交通拥堵",
    title: "高铁站前车流集中，落客平台即停即走",
    detail: "接站车辆建议驶入停车场，避免长时间占道。",
  },
  {
    time: "10:21",
    category: "游客见闻",
    title: "「美食老街」人少出片，外地游客错峰捡漏",
    detail: "本地居民推荐晚 9 点后再去，避开最挤时段。",
  },
];

export const tipGroups = [
  {
    title: "先做功课再出门",
    iconClass: "ri-calendar-check-line",
    tips: [
      "门票、预约与停车都先查官方渠道，别轻信「内部代订」。",
      "把核心项目放上午，热门排队留给返程前的那半天。",
      "出发前看一眼景区客流热度，临期可灵活换目的地。",
    ],
  },
  {
    title: "订酒店留好凭证",
    iconClass: "ri-shield-check-line",
    tips: [
      "下单前核对实拍图与到店条款，截图保存房态承诺。",
      "到店先验房再入住，房型不符当场联系平台取证。",
      "警惕「先确认再补差价」的话术，拒绝口头加价。",
    ],
  },
  {
    title: "上路看准实况",
    iconClass: "ri-roadster-line",
    tips: [
      "高速与高铁尽量避开午后 15–19 点的返程高峰。",
      "拥堵路段刷新实时路况，随时准备改走备选线路。",
      "接驳选官方摆渡，不坐无资质车辆，也不信加价代排队。",
    ],
  },
];

export const statBoard = [
  {
    label: "实时缓行路段",
    value: "23",
    unit: "段",
    trend: "较前一时段 +6",
    note: "多为跨省返程干道",
    tone: "secondary",
  },
  {
    label: "重点景区客流",
    value: "10",
    unit: "家",
    trend: "已至峰值区间",
    note: "午后明显拥挤",
    tone: "primary",
  },
  {
    label: "加开列车班次",
    value: "42",
    unit: "班",
    trend: "应对返程",
    note: "请留意官方增开信息",
    tone: "accent",
  },
  {
    label: "高铁站待客时长",
    value: "≈1.5",
    unit: "时",
    trend: "高峰波动中",
    note: "接站尽量即停即走",
    tone: "secondary",
  },
];

export const tickerItems = [
  "热榜：古城排队进山 4 小时实录刷屏",
  "快讯：绕城高速北段缓行约 8 公里",
  "提醒：民宿到店无房，先核对再入住",
  "现场：观景平台早场人少，建议错峰",
  "乱象：电瓶车私自揽客已被叫停",
];